/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Tab_MessagesInputs */

const cs_property_tab_messages = /** @type {(inputs: Property_Tab_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zprávy`)
};

const en_property_tab_messages = /** @type {(inputs: Property_Tab_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Property_Tab_MessagesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_tab_messages = /** @type {((inputs?: Property_Tab_MessagesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Tab_MessagesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_tab_messages(inputs)
	return cs_property_tab_messages(inputs)
});